import { LogOut } from "lucide-react";
import { ConfirmDialog } from "./ConfirmDialog";

interface SignOutDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function SignOutDialog({ isOpen, onClose, onConfirm }: SignOutDialogProps) {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Sign Out"
      description="Are you sure you want to sign out? You will need to log in again to access your dashboard."
      confirmText="Sign Out"
      cancelText="Cancel"
      variant="warning"
      icon={<LogOut className="w-5 h-5 text-muted-foreground" />}
    />
  );
}
